/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Layout.jsx
 * description   : {{insert here}}
 * creation date : 19/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    useEffect,
    useState,
    Fragment,
} from 'react';

import {
    useComponentContext,
    toolKit,
} from '@/components/core';

import {
    route_list,
} from '@/utils/router/core';

import {
    Outlet,
} from 'react-router-dom';

import {
    config_page_LIST_land_pages,
} from '../core';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Layout() {
    // Component context
    const { ctx } = useComponentContext();

    // State variables
    const [currentAuthState, set_currentAuthState] = useState(undefined);
    const [currentLocation, set_currentLocation] = useState(undefined);
    const [canBeDisplayed, set_canBeDisplayed] = useState(false);

    // Listen asynchronous events: Page load
    useEffect(() => {
        if (
            (ctx.runtime.isLoaded) &&
            (ctx.auth.state !== toolKit.enums.auth.stateTypes.UNMOUNTED)
        ) {
            // Get the current location
            const contextLocation = ctx.api.location.getLocation();

            // Detect any authentication change
            if (ctx.auth.state !== currentAuthState) {
                // Update the state
                set_currentAuthState(ctx.auth.state);
                set_currentLocation(undefined);
                set_canBeDisplayed(false);
            }

            if (
                (currentLocation !== contextLocation.path)
            ) {
                // Display flag
                var isAllowed = true;

                // Loop the landing pages list
                for (let i = 0; i < config_page_LIST_land_pages.length; i++) {
                    // Detect unauthenticated access to private pages
                    if (
                        (config_page_LIST_land_pages[i].path === contextLocation.path) &&
                        (true === config_page_LIST_land_pages[i].is_private) &&
                        (ctx.auth.state !== toolKit.enums.auth.stateTypes.AUTHENTICATED)
                    ) {
                        // Enable the flag
                        isAllowed = false;

                        // Navigate to the error page
                        ctx.api.location.navigate(
                            toolKit.api.location.buildUrl(
                                route_list.PAGE_NOT_FOUND
                            )
                        );
                    }
                }

                // Set the state variable
                set_currentLocation(contextLocation.path);
                set_canBeDisplayed(isAllowed);
            }
        }
    },
        [
            ctx,
            currentAuthState,
            currentLocation,
        ]
    );

    return (
        <Fragment>
            {/* Can be displayed */}
            {(true === canBeDisplayed) &&
                <Fragment>
                    <Outlet />
                </Fragment>
            }
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Layout;



// End of file
